import gallery from '@/assets/gall1.png';
import agency from '@/assets/agncy.png';
import 'react-quill/dist/quill.snow.css';
import { useEffect, useState } from 'react';
import { Button } from '@/components/Elements';

const Finalized = () => {

  return (
    <div className="agency-card-row accepted">
      <div className="row">
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <div className="d-flex agency-info-bs justify-between align-items-center">
              <h6 className="dark-gray mb-0">Agency 1</h6>
              <span className='submitted-tx'>Submitted</span>
            </div>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className="row">
              <div className="col-12 col-md-6">
                <h5 className="mb-0">---</h5>
                <p className="f-13">Expertise</p>
              </div>
              <div className="col-12 col-md-6">
                <h5 className="mb-0">2548458692</h5>
                <p className="f-13">Mobile NUmber</p>
              </div>
            </div>
           
            <Button className="rounded-full w-100 mt-2 f-13" size="sm">
            View submitted form
            </Button>
          </div>
        </div>
     
     
      </div>
    
    </div>
  );
};
export default Finalized;
